interface UPS_CALCULATOR_PROPS {
  basicAmount: number;
  serviceYears: number;
  pensionType: string;
}
export const UPS_FORMULA = ({
  basicAmount,
  serviceYears,
  pensionType,
}: UPS_CALCULATOR_PROPS) => {
  if (!basicAmount || !serviceYears) {
    return { pensionEarned: 0 };
  }

  let pensionEarned = 0;

  if (serviceYears < 10) {
    return { pensionEarned: '' };
  } else if (serviceYears >= 10 && serviceYears <= 24) {
    pensionEarned = (basicAmount / 2) * (serviceYears / 25);
  } else {
    pensionEarned = basicAmount / 2;
  }

  if (pensionEarned <= 10000) {
    pensionEarned = 10000;
  }

  if (pensionType === 'Family Pension') {
    pensionEarned *= 0.6;
  }

  return { pensionEarned };
};
